const state = () => ({
  isloggedin:false,
  token:"",
  user:null,
  socketconnected:false,
  redirectpath:null,
  userroles:[],
  supplierhaveopencustomattributes:false,
  supplieropencuatomattributes:[],
  suppliernotifications:[],
  redirectroute:null,
  userip:null,
  consent_statuses:[],
});
const getters = {
  isloggedin(state){
    return state.isloggedin
  },
  token(state){
    return state.token
  },
  user(state){
    return state.user
  },
  socketconnected(state){
    return state.socketconnected
  },
  redirectpath(state){
    return state.redirectpath
  },
  userroles(state){
    return state.userroles
  },
  supplierhaveopencustomattributes(state){
    return state.supplierhaveopencustomattributes
  },
  supplieropencuatomattributes(state){
    return state.supplieropencuatomattributes
  },
  suppliernotifications(state){
    return state.suppliernotifications
  },
  redirectroute(state){
    return state.redirectroute
  },
  userip(state){
    return state.userip
  },
  consent_statuses(state){
    return state.consent_statuses
  },
};
const  mutations =  {
  SET_LOGGEDIN(state,data){
    state.isloggedin = data
  },
  SET_TOKEN(state,data){
    state.token = data
  },
  SET_USER(state,data){
    state.user = data
  },
  SET_SOCKET_CONNECTED(state,data){
    state.socketconnected = data
  },
  SET_REDIRECT_PATH(state,data){
    state.redirectpath = data
  },
  SET_USERROLES(state,data){
    state.userroles = data
  },
  SET_SUPPLIER_HAVE_OPEN_CUSTOM_ATTRIBUTES(state,data){
    state.supplierhaveopencustomattributes = data
  },
  SET_SUPPLIER_OPEN_CUSTOM_ATTRIBUTES(state,data){
    state.supplieropencuatomattributes = data
  },
  SET_SUPPLIER_NOTIFICATIONS(state,data){
    state.suppliernotifications = data
  },
  SET_REDIRECT_ROUTE(state,data){
    state.redirectroute = data
  },
  SET_USER_IP(state,data){
    state.userip = data
  },
  SET_CONSENT_STATUSES(state,data){
    state.consent_statuses = data
  },
};
const actions =  {
  setLoggedin({commit},data)  {
    commit("SET_LOGGEDIN",data)
  },
  setToken({commit},data)  {
    commit("SET_TOKEN",data)
  },
  setUser({commit},data)  {
    commit("SET_USER",data)
  },
  setSocketConnected({commit},data)  {
    commit("SET_SOCKET_CONNECTED",data)
  },
  setRedirectPath({commit},data)  {
    commit("SET_REDIRECT_PATH",data)
  },
  setUserRoles({commit},data)  {
    commit("SET_USERROLES",data)
  },
  setSupplierHaveOpenCustomAttributes({commit},data)  {
    commit("SET_SUPPLIER_HAVE_OPEN_CUSTOM_ATTRIBUTES",data)
  },
  setSupplierOpenCustomAttributes({commit},data)  {
    commit("SET_SUPPLIER_OPEN_CUSTOM_ATTRIBUTES",data)
  },
  setSupplierNotifications({commit},data)  {
    commit("SET_SUPPLIER_NOTIFICATIONS",data)
  },
  setRedirectRoute({commit},data)  {
    commit("SET_REDIRECT_ROUTE",data)
  },
  setUserIp({commit},data)  {
    commit("SET_USER_IP",data)
  },
  setConsentStatuses({commit},data)  {
    commit("SET_CONSENT_STATUSES",data)
  },
}

export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
};

